import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { audioAlertService } from "../Utils/audioService";

export default function AudioEnableBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!audioAlertService.isUnlocked) {
      setShow(true);
    }
  }, []);

  const handleUnlock = () => {
    audioAlertService.unlockAudio();
    setShow(false);
  };

  if (!show) return null;

  return (
    <Button
      variant="contained"
      onClick={handleUnlock}
      sx={{
        backgroundColor: "#d32f2f !important",
        color: "white !important",
        fontWeight: "bold",
        textTransform: "none",
        marginRight: 2,
        borderRadius: "8px",
        padding: "6px 16px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        "&:hover": { backgroundColor: "#b71c1c !important" },
      }}
    >
      Click to Enable Sounds
    </Button>
  );
}
